import React from 'react'
import './Header.css'
function Header() {
  return (
    <div>
       <div className="header">
        <div className="header-contents">
            <h2>Order your favorite food from here!</h2>
            <p>Experience the Art of Culinary Excellence at Tomato, where our expertly crafted dishes are delivered straight to your door, bringing gourmet flavors and exceptional quality to your table without the need to step out.Choose from our diverse menu of expertly crafted dishes, delivered straight to your door, and enjoy a culinary experience that brings exceptional flavors and convenience right to your home.</p>
       <button>View Menu</button> 
       </div>
       </div>

    </div>
  )
}

export default Header